import { useEffect, useState } from 'react';
import axios from 'axios';

const apiUrl = "https://elcobradorleague.com/api";

export const usePlayerHonor = (idplayer, idleague) => {
  const [playerHonorData, setPlayerHonorData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // 🔒 Validación temprana
    if (!idplayer || !idleague) {
      setPlayerHonorData([]);
      setLoading(false);
      return;
    }

    const controller = new AbortController();

    const fetchPlayerHonor = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await axios.get(
          `${apiUrl}/api.php?endpoint=playerhonor&idplayer=${idplayer}&idleague=${idleague}`,
          {
            headers: {
          'X-API-TOKEN': process.env.REACT_APP_API_TOKEN
        },
            signal: controller.signal
          }
        );

        setPlayerHonorData(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        if (err.name !== 'CanceledError') {
          setError(err);
          setPlayerHonorData([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPlayerHonor();
    return () => controller.abort();
  }, [idplayer, idleague]);

  return { playerHonorData, loading, error };
};

